import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerNotificheSdiModalComponent } from './worker-notifiche-sdi-modal';

export const WorkerNotificheSdiModalModule: string = ng
    .module('worker-notifiche-sdi-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerNotificheSdiModalComponent', WorkerNotificheSdiModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-notifiche-sdi-modal/worker-notifiche-sdi-modal.module.ts